export default "__VITE_ASSET__DWMeo6ra__"